import * as React from 'react';
import { useMutation } from '@tanstack/react-query';
import { SegmentAttributeGroupPair } from '../models/segments';
import { AppProviderDispatch, AppContext } from '../shared/app-context';
import useRestService from '../shared/rest-service';
import { unmapTransactionalAttributes } from '../utilities/attribute-filter';

interface ExportConfig {
  fileName: string | null;
  attributes: SegmentAttributeGroupPair;
}

export function useSegmentExport() {
  const appState = React.useContext<AppProviderDispatch>(AppContext);
  const { fetchWrapper } = useRestService();

  return useMutation<Blob, Error, ExportConfig>((exportConfig) => {
    return fetchWrapper(
      `api/${appState.state.clientId}/segments/customers/csv`,
      {
        method: 'POST',
        body: JSON.stringify({
          ...exportConfig,
          attributes: {
            ...exportConfig.attributes,
            include: {
              ...exportConfig.attributes.include,
              predicates: unmapTransactionalAttributes(exportConfig.attributes.include.predicates)
            },
            exclude: {
              ...exportConfig.attributes.exclude,
              predicates: unmapTransactionalAttributes(exportConfig.attributes.exclude?.predicates)
            }
          }
        })
      },
      'blob'
    );
  });
}
